import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getHeaders = () => {
  const lang = localStorage.getItem("lang") || "en";

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Accept-Language": lang,
  };
};

const buildQueryParams = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return query.toString();
};

export const getStockHistoryFilters = async () => {
  try {
    const response = await api.get(
      `${API_BASE_URL}api/stock-history-report/filters`,
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get Stock History Filters API Error:", error);
    throw error?.response?.data || {
      message: "Failed to fetch stock history filters",
    };
  }
};

export const getStockHistoryReport = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/stock-history-report/list${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Get Stock History Report API Error:", error);
    throw error?.response?.data || {
      message: "Failed to fetch stock history report",
    };
  }
};

export const getStockHistorySummary = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/stock-history-report/summary${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Get Stock History Summary API Error:", error);
    throw error?.response?.data || {
      message: "Failed to fetch stock history summary",
    };
  }
};

export const downloadStockHistoryExcel = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/stock-history-report/download/excel${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `stock-history-report-${Date.now()}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return true;
  } catch (error) {
    console.error("Download Stock History Excel API Error:", error);
    throw error?.response?.data || {
      message: "Failed to download stock history excel",
    };
  }
};

export const downloadStockHistoryPdf = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/stock-history-report/download/pdf${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `stock-history-report-${Date.now()}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return true;
  } catch (error) {
    console.error("Download Stock History PDF API Error:", error);
    throw error?.response?.data || {
      message: "Failed to download stock history pdf",
    };
  }
};